const apiVersion = `v${1}`;

const SENTRY_DSN = process.env.SENTRY_DSN;
const ROOT_URL = process.env.ROOT_URL;
const ROOT_URL_SOCKET = process.env.ROOT_URL_SOCKET;
const FUSE_ORGANIZATION_API_KEY = process.env.FUSE_ORGANIZATION_API_KEY;
const FUSE_ORDER_IMPORTER_TEMPLATE_ID = process.env.FUSE_ORDER_IMPORTER_TEMPLATE_ID;
const CLARITY_ID = process.env.CLARITY_ID;

// Prod gate. The new ECS stack ships ENV="prod"; the legacy stack shipped
// ENV="production". Accept both so integrations (Intercom, LogRocket) and
// prod-only branches gate consistently regardless of which stack built us.
const isProd = () => ["prod", "production"].includes(process.env.ENV);

const tagManagerArgs = {
  gtmId: process.env.GOOGLE_TAG_MANAGER_ID || "",
};

const intercomSettings = {
  app_id: process.env.INTERCOM_APP_ID || "",
};

// The backend's default_storage.url() returns an absolute S3 URL in prod/UAT
// (S3 storage) but a relative "/media/..." path in local dev (FileSystemStorage).
// Only prepend ROOT_URL for the relative case; prepending it to an absolute S3
// URL produces a malformed "app.factory.apphttps://..." that fails DNS.
const resolveFileUrl = (path) => (/^https?:\/\//i.test(path) ? path : `${ROOT_URL}${path}`);

const API_URL = `${ROOT_URL}/api/${apiVersion}/`;

// The customer-facing API sits behind its own front door, NOT the app host:
// prod is api.factory.app, every other environment is <env>-api.factory.app.
// This mirrors api_proxy_host in factory-infra (terraform/03_locals.tf) — if
// that naming rule ever changes, this has to change with it.
// Its /v1 is the public contract's version and is unrelated to apiVersion
// above, which versions the internal Django API.
const PUBLIC_API_URL = isProd()
  ? "https://api.factory.app/v1"
  : `https://${process.env.ENV}-api.factory.app/v1`;
const HTML_TO_PDF_URL = `${process.env.HTML_TO_PDF_URL}/`;
const SEARCH_URL = `${process.env.SEARCH_URL ? process.env.SEARCH_URL : process.env.ROOT_URL}/`;
const SOCKET_URL = `${ROOT_URL_SOCKET}/ws/`;

export default API_URL;

export {
  API_URL,
  CLARITY_ID,
  SEARCH_URL,
  FUSE_ORDER_IMPORTER_TEMPLATE_ID,
  FUSE_ORGANIZATION_API_KEY,
  HTML_TO_PDF_URL,
  intercomSettings,
  isProd,
  PUBLIC_API_URL,
  resolveFileUrl,
  ROOT_URL,
  ROOT_URL_SOCKET,
  SENTRY_DSN,
  SOCKET_URL,
  tagManagerArgs,
};

/* eslint-enable */
